import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import Config from 'config';
import { isEmpty } from 'lodash';
import KEY_CURRICULUM_PROGRESS_ASYNC_QUERY from 'graph/reports/key-curriculum-progress-report-async-query';
import RadialChartCard, { ChartData } from '../../../../charts/RadialChartCard';
import useReportQueryParams from '../../../../hooks/use-report-query-params';
import { ChartCardType } from '../../../../types';
import { getQueryVariables } from '../../../../utils/report-param-utils';

const OverallCurriculumProgressChart: React.FC = () => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCommon']);
  const [{ entityId, entityType }] = useReportQueryParams();
  const [fetchReport, { data, error, stopPolling }] = useLazyQuery(
    KEY_CURRICULUM_PROGRESS_ASYNC_QUERY,
    {
      pollInterval: Config.reporting.asyncPollIntervalMs
    }
  );

  useEffect(() => {
    fetchReport({ variables: getQueryVariables({ entityId, entityType }) as any });
  }, [fetchReport, entityId, entityType]);

  const chartData: ChartData = {};

  if (error) {
    stopPolling?.();
  } else if (data?.keyCurriculumProgressReportAsync?.result) {
    stopPolling?.();

    const { curriculumProgressPercentage } = data.keyCurriculumProgressReportAsync.result;
    chartData.progress = curriculumProgressPercentage;
    chartData.total = 100;
  }

  return (
    <RadialChartCard
      type={ChartCardType.PERCENT}
      title={t('Overall Curriculum Progress')}
      helpText={t('curriculumProgress', { ns: 'ReportsHelpCommon' })}
      color="#4ae2a7"
      loading={isEmpty(chartData)}
      {...chartData}
    />
  );
};

export default React.memo(OverallCurriculumProgressChart);
